export enum ImageStatus {
    LIVE,
    DELETED,
    UNKNOWN,
    INREVIEW,
    ATTACHMENT,
    PRIVATE
}